import React, { useState } from 'react';
import { Dropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';


const SelectFilter = (props) => {
    
    const [selectedOption, setSelectedOption] = useState(props.selected || props.options[0]);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen(prevState => !prevState);
    
    const options = props.options.map(opt => <DropdownItem key={opt} onClick={() => chooseOption(opt)}>{opt}</DropdownItem>);

    const chooseOption = (chosenOption) => {
        setSelectedOption(chosenOption);
        console.log('CHOSEN OPTION', chosenOption, dropdownOpen);
        props.onChange(chosenOption);
    }

    return (
        <>
            <Dropdown className="mr-1" isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle color="info" caret block>
                    {selectedOption}
                </DropdownToggle>
                <DropdownMenu className="btn-block">
                    {options}
                </DropdownMenu>
            </Dropdown>
        </>);
}
export default SelectFilter;